import { ChevronLeft, ChevronRight } from "react-feather";

const { useState, createRef, useEffect } = require("react");

export const Carousel = ({ images }) => {
  const [currentImage, setCurrentImage] = useState(0);
  const refs = images.reduce((acc, val, i) => {
    acc[i] = createRef();
    return acc;
  }, {});

  const scrollToImage = (i) => {
    setCurrentImage(i);
    refs[i].current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  };

  const totalImages = images.length;

  const nextImage = () => {
    if (currentImage >= totalImages - 1) {
      scrollToImage(0);
    } else {
      scrollToImage(currentImage + 1);
    }
  };

  const previousImage = () => {
    if (currentImage === 0) {
      scrollToImage(totalImages - 1);
    } else {
      scrollToImage(currentImage - 1);
    }
  };

  const arrowStyle =
    "absolute text-white text-2xl z-10 h-10 w-10 rounded-full opacity-75 flex items-center justify-center";

  const sliderControl = (isLeft) => (
    <button
      type="button"
      onClick={isLeft ? previousImage : nextImage}
      className={`${arrowStyle} ${isLeft ? "left-2" : "right-2"}`}
      style={{ top: "40%" }}
    >
      <span role="img" aria-label={`Arrow ${isLeft ? "left" : "right"}`}>
        {isLeft ? <ChevronLeft /> : <ChevronRight />}
      </span>
    </button>
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const nextIndex = (currentImage + 1) % totalImages;
      scrollToImage(nextIndex);
    }, 3000);
    return () => clearInterval(interval);
  }, [currentImage]);

  return (
    <div className="flex justify-center w-100 items-center">
      <div className="relative w-full">
        <div className="carousel">
          {sliderControl(true)}
          {images.map((img, i) => (
            <div className="w-full flex-shrink-0" key={i} ref={refs[i]}>
              <img
                src={img.src}
                alt=""
                className="w-full object-contain rounded-lg shadow"
              />
            </div>
          ))}
          {sliderControl()}
        </div>
      </div>
    </div>
  );
};
